import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import {
  PHARMACY_INVOICE_FROM,
  PHARMACY_PRODUCT_TYPE,
  PHARMACY_PRODUCT_TYPE_MENUS,
  PHARMACY_SUPPLIER
} from '../../../../../constants/dropdown';
import { PHARMACY_TYPE_MENUS } from '../../../../../constants/dropdown';
import { AddTCDForm } from './AddTCDform';
import { AddDetails } from './AddDetails';
import { dateFormatter } from '../../../../../utils';
import { GrnAddDetails } from './GrnAddDetails';
import axios from 'axios';

const TAX_SUMMARY_HEADER = [
  { header: 'GST%', accessor: 'gst' },
  { header: 'Taxable Amount', accessor: 'taxable' },
  { header: 'CGST Amt', accessor: 'cgst' },
  { header: 'SGST Amt', accessor: 'sgst' },
  { header: 'IGST Amt', accessor: 'igst' }
];

const PATIENT_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'OP No', accessor: 'op_no' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
  {
    header: 'GRN No',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.cnt}`}
        </span>
      );
    }
  },
  {
    header: 'GRN Type',
    accessor: 'type'
  },
  {
    header: 'GRN Date',
    accessor: (row) => `${getCurrentDateTime('date', row.cnt_date)}`
  },
  {
    header: 'Product Type',
    accessor: 'type'
  },
  {
    header: 'Location',
    accessor: (row) => row?.location?.warehouse_name
  },
  {
    header: 'Supplier Name',
    accessor: (row) => row?.supplier?.ledger_name
  },
  {
    header: 'Invoice No',
    accessor: 'invoice_no'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Created At',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const initialgrnDataObj = {
  data: [],
  loading: false
};

export const GoodReceiptNote = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [grnDataObj, setGrnDataObj] = useState(initialgrnDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [patientDataList, setPatientDataList] = useState([]);
  const [warehouse, setWareHosue] = useState([]);
  const [addtcdDialogue, setAddtcdDialogue] = useState(false);
  const [addDetailsDialogue, setAddDetailsDialogOpen] = useState(false);
  const [accountLedger, setAccountLedger] = useState([]);
  const [productDropdown, setProductDropdown] = useState([]);
  const [filteredServiceList, setFilteredServiceList] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        invoice_no: Yup.string().required(' '),
        invoice_from: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      grn_date: new Date().toISOString().split('T')[0],
      invoice_date: new Date().toISOString().split('T')[0],
      type: 'Direct',
      product_type: 'Pharmacy Product',
      bill: {
        out_sourced: 'No',
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const column = watch('view_column');
  const BILL_TABLE_HEADER = [
    { header: 'PO No.', accessor: 'po_no' },
    { header: 'Product Name', accessor: (row) => row?.product_name || row?.product?.main?.name },
    column ? { header: 'HSN Code', accessor: 'hsn_code' } : null,
    column ? { header: 'Packing', accessor: 'packing' } : null,
    column ? { header: 'UnitId', accessor: 'unit_id' } : null,
    { header: 'Unit', accessor: 'unit' },
    { header: 'PO Qty', accessor: 'po_qty' },
    { header: 'Bill Qty', accessor: 'bill_qty' },
    { header: 'Free Qty', accessor: 'free_qty' },
    { header: 'Rate', accessor: 'rate' },
    { header: 'Amount', accessor: 'amount' },
    { header: 'Disc Amt', accessor: 'dis_amt' },
    { header: 'Taxable', accessor: 'taxable' },
    { header: 'Gst%', accessor: 'gst' },
    column ? { header: 'CGST Amt', accessor: 'cgst' } : null,
    column ? { header: 'SGST Amt', accessor: 'sgst' } : null,
    column ? { header: 'IGST Amt', accessor: 'igst_amt' } : null,
    { header: 'Net Amt', accessor: 'net_amt' },
    { header: 'MRP', accessor: 'mrp' },
    { header: 'Batch No.', accessor: 'batch_no' },
    {
      header: 'Exp Date',
      accessor: (row) => `${getCurrentDateTime('date', row.exp_date)}`
    }
  ].filter(Boolean);

  useEffect(() => {
    let total_qty = 0;
    let total_amt = 0;
    let disc_amt = 0;
    let net_amt = 0;
    let gst_amt = 0;

    detailList.forEach((detail) => {
      total_qty += detail.rec_qty;
      total_amt += detail.amount;
      disc_amt += detail.disc_amt;
      gst_amt += detail.gst_amt;
      net_amt += detail.net_amt;
    });

    // Round net_amt to the nearest integer
    const roundedNetAmt = Math.round(net_amt);

    // Calculate the round off difference (original net_amt - rounded net_amt)
    const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));

    // Set the calculated values
    setValue('total_qty', total_qty);
    setValue('total_amt', total_amt);
    setValue('disc_amt', disc_amt);
    setValue('gst_amt', gst_amt);
    setValue('net_amt', roundedNetAmt); // Set the rounded value as net_amt
    setValue('round_off', Math.abs(roundOff)); // Set the absolute value of the round off difference
  }, [detailList, setValue]);

  const netAmtWatch = watch('bill.net_amt');
  const recAmt1Watch = watch('bill.rec_amt_1');
  const recAmt2Watch = watch('bill.rec_amt_2');
  const payMode = watch('bill.pay_mode');

  console.log(detailList, 'DETAILL LSIT');
  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    let balanceAmt = netAmtWatch - total_recpt;
    if (payMode === 'CASH') {
      setValue('bill.rec_amt_1', netAmtWatch);
      setValue('bill.rec_amt_2', 0);
      setValue('bill.balance_amt', 0);
      setValue('bill.total_recpt', netAmtWatch);
    } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
      setValue('bill.rec_amt_1', 0);
      setValue('bill.rec_amt_2', netAmtWatch);
      setValue('bill.balance_amt', 0);
      setValue('bill.total_recpt', netAmtWatch);
    } else {
      setValue('bill.total_recpt', total_recpt);
      setValue('bill.balance_amt', balanceAmt);
    }
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'add_details',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setDetailList(selectedRecord.add_details);
      setValue('invoice_no', selectedRecord?.invoice_no);
      setValue('cnt', selectedRecord?.cnt);
      setValue('cnt_date', selectedRecord?.cnt_date);
      const formattedInvDate = selectedRecord?.invoice_date
        ? new Date(selectedRecord.invoice_date).toISOString().split('T')[0]
        : '';
      setValue('invoice_date', formattedInvDate);
      setValue('type', selectedRecord?.type);
      setValue('supplier', selectedRecord?.supplier?._id);
      setValue('location', selectedRecord?.location?._id);
      setValue('product_type', selectedRecord?.product_type);
      setValue('invoice_from', selectedRecord?.invoice_from);
      setValue('amd_no', selectedRecord?.amd_no);
      setValue('remarks', selectedRecord?.remarks);
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);

  const getAccountLedgerData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setAccountLedger(data);
  }, []);

  useEffect(
    () => {
      getAccountLedgerData();
    },
    { getAccountLedgerData }
  );

  const getProductDropdown = useCallback(async () => {
    const data = await axios.get(`${BASE_URL}/product-master/dropdown?limit=${50}`);
    if (data?.data.data) {
      setProductDropdown(data.data.data);
      setFilteredServiceList(data.data.data);
    }
  }, []);

  useEffect(() => {
    getProductDropdown();
  }, [getProductDropdown]);

  const formSubmit = async (formValues) => {
    if (detailList.length === 0) {
      toast('Please add the Details first', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const payload = { ...formValues, add_details: detailList };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/grn-update' : '/grn-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    console.log(response, 'HELLO RESPONSE');
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Good Receipt Note`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Good Receipt Note`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleRowDelete = (rowId) => {
    setDetailList((prev) =>
      prev.filter((data) => {
        return data.product !== rowId;
      })
    );
  };

  const onDetailAddHandler = (data) => {
    const existingDetail = detailList.find(({ product }) => product === data.product);
    if (existingDetail) {
      toast('Product already chosen', { variant: 'error' });
      return;
    }
    const productName = productDropdown.find(({ _id }) => _id === data.product)?.main?.name;
    setDetailList((prev) => [
      ...prev,
      {
        ...data,
        product_name: productName
      }
    ]);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/grn-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Good Receipt Note', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Good Receipt Note', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/grn-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Good Receipt Note', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Good Receipt Note', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setGrnDataObj({ loading: true });
    const response = await request('/grn-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setGrnDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setGrnDataObj({ loading: false });
    }
  };

  useEffect(() => {
    if (grnDataObj.data && grnDataObj.data.length > 0) {
      setOriginalData(grnDataObj.data);
      setIsFiltered(false);
    }
  }, [grnDataObj.data]);

  useEffect(() => {
    handleGrnSearch(input);
  }, [input]);

  const handleGrnSearch = async () => {
    const lowercasedInput = input.toUpperCase().trim();
    const limit = 10;
    try {
      const response = await request('/grn-list', {
        method: 'GET',
        query: { name: lowercasedInput, limit: limit }
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setGrnDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setGrnDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setGrnDataObj({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const getWarehouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultWarehouse] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultWarehouse?._id);
    }
    setWareHosue(data);
  }, []);

  useEffect(() => {
    getWarehouseDropdown();
  }, [getWarehouseDropdown]);

  const summary = watch('show_summary');

  const groupDataByGST = (data) => {
    const groupedData = {};

    // Group data by GST%
    data.forEach((item) => {
      if (!groupedData[item.gst]) {
        groupedData[item.gst] = {
          gst: item.gst,
          taxable: 0,
          cgst: 0,
          sgst: 0,
          igst: 0,
          count: 0
        };
      }

      // Aggregate values for each group
      groupedData[item.gst].taxable += item.taxable;
      groupedData[item.gst].cgst += item.cgst;
      groupedData[item.gst].sgst += item.sgst;
      groupedData[item.gst].igst += item.igst;
      groupedData[item.gst].count += 1;
    });

    // Convert groupedData object to array for rendering in table
    return Object.values(groupedData);
  };
  const groupedData = groupDataByGST(detailList || []);
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Good Receipt Note(GRN)
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>GRN Date</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.3 }}
                    type="date"
                    name="grn_date"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>GRN/Amd No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.3 }}
                    name="cnt"
                    placeholder="GRN"
                  />
                  <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.2 }} name="amd_no" />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="type"
                    placeholder="Type"
                    menus={PHARMACY_TYPE_MENUS}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Invoice No</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.3 }}
                    name="invoice_no"
                    placeholder="Invoice No"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Invoice Date</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.5 }}
                    name="invoice_date"
                    type="date"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.28, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.3 }}
                    name="location"
                    placeholder="Location"
                    menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))}
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="product_type"
                    menus={PHARMACY_PRODUCT_TYPE_MENUS}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Supplier</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.9 }}
                    name="supplier"
                    menus={accountLedger.map((data) => ({
                      ...data,
                      name: data.ledger_name
                    }))}
                    placeholder="Select Supplier"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Invoice From</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="invoice_from"
                    placeholder="Invoice From"
                    menus={accountLedger.map((data) => ({
                      ...data,
                      name: data.ledger_name
                    }))}
                  />
                </Stack>
              </Stack>
            </Box>

            <Grid
              item
              xs={12}
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, boxShadow: '0px 2px 2px #0099ff' }}
            >
              <Stack spacing={1} direction="row" justifyContent="space-between">
                <Button
                  variant="contained"
                  disabled={!['new', 'edit'].includes(currentAction)}
                  onClick={() => setAddDetailsDialogOpen(true)}
                >
                  Add Details
                </Button>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="view_column"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '14px' }}>
                    View All Columns in Table
                  </Typography>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="show_summary"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '14px' }}>Show Summary</Typography>
                </Stack>
              </Stack>
              <Table
                containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                data={detailList.map((data) => ({ _id: data.product, ...data }))}
                columns={BILL_TABLE_HEADER}
                size="small"
                showDeleteAction={true}
                onDeleteHandler={handleRowDelete}
              />
            </Grid>
            {summary === true && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={groupedData || []}
                  columns={TAX_SUMMARY_HEADER}
                  size="small"
                  onDeleteHandler={handleRowDelete}
                />

                <Stack sx={{ flex: 1 }} spacing={0.5} direction="column">
                  {/* Total Qty */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Qty</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="total_qty" />
                  </Stack>
                  {/* Total Amount */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Amount</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="total_amt" />
                  </Stack>
                  {/* Total TCD */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total TCD</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="total_tcd" />
                  </Stack>
                  {/* Round Off */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Round Off</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="round_off" />
                  </Stack>
                  {/* Net Amount */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Net Amount</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="net_amt" />
                  </Stack>
                  {/* Remarks */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.7 }}
                      name="remarks"
                      placeholder="Enter Remarks"
                    />
                  </Stack>
                </Stack>
              </Stack>
            )}
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            GRN Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search GRN "
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={grnDataObj?.data || []}
          loading={grnDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>

      {/* <Dialog
                open={addtcdDialogue}
                onClose={() => setAddtcdDialogue(false)}
                PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <AddTCDForm
                    onClose={() => setAddtcdDialogue(false)}
                />
            </Dialog> */}

      <Dialog
        open={addDetailsDialogue}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '75%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <GrnAddDetails
          onClose={() => setAddDetailsDialogOpen(false)}
          onAdd={onDetailAddHandler}
          productDropdown={productDropdown}
          filteredServiceList={filteredServiceList}
          setFilteredServiceList={setFilteredServiceList}
          setProductDropdown={setProductDropdown}
        />
      </Dialog>
    </>
  );
};
